import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=5d5ac955&scoped=true&"
import script from "./DocumentLink.vue?vue&type=script&lang=ts&"
export * from "./DocumentLink.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentLink.vue?vue&type=style&index=0&id=5d5ac955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ac955",
  null
  
)

export default component.exports